// Stax Payment Configuration
// This file contains the configuration for Stax payment integration

export const staxConfig = {
  // Public key for Stax (this is safe to expose in frontend)
  // In production, this should come from environment variables
  publicKey: process.env.REACT_APP_STAX_PUBLIC_KEY || 'pk_test_placeholder',
  
  // Environment: 'production' or 'sandbox'
  environment: process.env.REACT_APP_STAX_ENVIRONMENT || 'sandbox',
  
  // Supported card brands
  supportedCardBrands: ['visa', 'mastercard', 'amex', 'discover'],
  
  // Card brand logos mapping
  cardBrandLogos: {
    visa: '/assets/card-logos/visa.svg',
    mastercard: '/assets/card-logos/mastercard.svg',
    amex: '/assets/card-logos/amex.svg',
    discover: '/assets/card-logos/discover.svg',
    generic: '/assets/card-logos/generic.svg'
  },
  
  // Error messages
  errorMessages: {
    tokenization_failed: 'Failed to process card information. Please try again.',
    invalid_card: 'Please enter a valid card number.',
    expired_card: 'This card has expired. Please use a different card.',
    network_error: 'Network error. Please check your connection and try again.',
    generic_error: 'An error occurred. Please try again.'
  }
};